<ngx-spinner [name]="'relatorio-comissao'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Fechar comissão vendedores</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Referência</mat-label>
                    <input type="text" matInput [(ngModel)]="stringDataComissao" readonly>
                </mat-form-field>
            </div>

            <div class="col-auto" *ngIf="!bExportar && !bComissaoGerada">
                <button class="mt-4" mat-flat-button color="primary" (click)="fecharComissao()">
                    <mat-icon>cached</mat-icon> Fechar comissão
                </button>
            </div>
        </div>


        <div class="row" *ngIf="bExportar">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <div class="row mt-2">
                    <div class="col-sm text-right">
                        <button mat-flat-button color="warn" (click)="exportar()">
                            <mat-icon>print</mat-icon> Exportar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>